import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';
import { text_styles, Typography } from '../../foundation';

export type BaseTextAlignment = 'center' | 'leading' | 'trailing';

const TEXT_ALIGNMENT_BY_ALIGNMENT: Record<BaseTextAlignment, string> = {
  leading: 'left',
  trailing: 'right',
  center: 'center',
};

export type BaseTextElement = keyof Pick<
  JSX.IntrinsicElements,
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span' | 'li'
>;

export interface BaseTextProps extends React.Attributes {
  alignment?: BaseTextAlignment;
  /** @default 'span' */
  as?: BaseTextElement;
  color?: string;
  /** @default Body_13_Regular
   * 'inherit'으로 부모 스타일을 상속받을 수 있습니다.
   *  */
  typography?: Typography | 'inherit';
}

export type BaseTextComponentProps = BaseTextProps & JSX.IntrinsicElements[BaseTextElement];

export const BaseText: React.FC<BaseTextComponentProps> = ({
  as = 'span',
  typography = 'Body_13_Regular',
  children,
  className,
  ...props
}) => {
  return (
    <Base className={classNames('pds-text', className)} as={as} typography={typography} {...props}>
      {children}
    </Base>
  );
};

const Base = styled.span<BaseTextProps>`
  margin: 0;
  ${({ typography }) => {
    // typography가 'inherit'이면 부모 스타일 상속
    if (typography === 'inherit') return '';
    return text_styles[typography ?? ('Body_13_Regular' as Typography)];
  }};
  ${({ color }) => color && `color: ${color}`};
  ${({ alignment }) => alignment && `text-align: ${TEXT_ALIGNMENT_BY_ALIGNMENT[alignment]}`};
`;
